import { Expose, Type } from 'class-transformer';
import { TestingStatus } from '../../enums/confirmatory-testing';

export class YearlyTestRecordResponseDto {
    /**
     * Unique identifier for the yearly test record
     * @example 'a1b2c3d4-e5f6-7890-1234-567890abcdef'
     */
    @Expose()
    id: string;

    /**
     * Reference to the confirmatory testing schedule
     * @example 'a1b2c3d4-e5f6-7890-1234-567890abcdef'
     */
    @Expose()
    scheduleId: string;

    /**
     * Testing year
     * @example 2025
     */
    @Expose()
    year: number;

    /**
     * Lot number for the test
     * @example '(L) 2022945'
     */
    @Expose()
    lotNumber?: string;

    /**
     * Bulk lot number
     * @example '(Bulk (L) 2H004A)'
     */
    @Expose()
    bulkLotNumber?: string;

    /**
     * Testing status
     * @example 'Complete'
     */
    @Expose()
    testingStatus: TestingStatus;

    /**
     * Date when testing is scheduled to occur
     * @example '2025-03-15T00:00:00.000Z'
     */
    @Expose()
    @Type(() => Date)
    scheduledDate?: Date;

    /**
     * Date when testing was completed
     * @example '2025-03-15T00:00:00.000Z'
     */
    @Expose()
    @Type(() => Date)
    testingCompleteDate?: Date;

    /**
     * Additional notes
     * @example 'testing complete in 2024'
     */
    @Expose()
    notes?: string;

    /**
     * Timestamp when the record was created
     * @example '2024-01-15T10:30:00.000Z'
     */
    @Expose()
    @Type(() => Date)
    createdAt: Date;

    /**
     * Timestamp when the record was last updated
     * @example '2024-01-15T15:45:00.000Z'
     */
    @Expose()
    @Type(() => Date)
    updatedAt: Date;
}


